import {take, call, put, select} from 'redux-saga/effects'

import {
  SENDING_CAMERAS_REQUEST,
  FETCH_ACCOUNTS_REQUEST,
  FETCH_CAMERAS_REQUEST,
  FETCH_CAMERAS_SUCCESS,
  FETCH_CAMERAS_FAILURE,
  SENDING_CAMERA_CREATE,
  CREATE_CAMERA_REQUEST,
  //CREATE_CAMERA_SUCCESS,
  CREATE_CAMERA_FAILURE,
  SENDING_CAMERA_UPDATE,
  UPDATE_CAMERA_REQUEST,
  //UPDATE_CAMERA_SUCCESS,
  UPDATE_CAMERA_FAILURE,
  SENDING_CAMERA_DELETE,
  DELETE_CAMERA_REQUEST,
  //DELETE_CAMERA_SUCCESS,
  DELETE_CAMERA_FAILURE,
  FETCH_CAMERA_CATEGORIES_SUCCESS,
  FETCH_CAMERA_CATEGORIES_FAILURE,
  FETCH_CAMERAS_BY_PERMISSION_REQUEST,
  FETCH_CAMERAS_BY_PERMISSION_SUCCESS,
  FETCH_CAMERAS_BY_PERMISSION_FAILURE,
  SENDING_CAMERAS_BY_PERMISSION_REQUEST,
} from '../actions/constants'
import camera from '../api/camera'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;
const getStationIDFromState = (state) => state.station.currentStation.ID;

function* fetchCameras({token, systemID, stationID}) {
  yield put({type: SENDING_CAMERAS_REQUEST, sending: true})
  try {
    return yield call(camera.fetchCameras, token, systemID, stationID)
  } catch (error) {
    yield put({type: FETCH_CAMERAS_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_CAMERAS_REQUEST, sending: false})
  }
}

export function* watchFetchCameras() {
  while (true) {
    yield take([FETCH_CAMERAS_REQUEST, FETCH_ACCOUNTS_REQUEST])
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const stationID = yield select(getStationIDFromState);
    const response = yield call(fetchCameras, {token, systemID, stationID})
    const arr = yield call(putNotify, {response})
    const cameras = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_CAMERAS_SUCCESS, cameras: cameras});
  }
}

function* fetchCamerasByPermission({token, systemID}) {
  yield put({type: SENDING_CAMERAS_BY_PERMISSION_REQUEST, sending: true})
  try {
    return yield call(camera.fetchCamerasByPermission, token, systemID)
  } catch (error) {
    yield put({type: FETCH_CAMERAS_BY_PERMISSION_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_CAMERAS_BY_PERMISSION_REQUEST, sending: false})
  }
}

export function* watchFetchCamerasByPermission() {
  while (true) {
    yield take(FETCH_CAMERAS_BY_PERMISSION_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(fetchCamerasByPermission, {token, systemID})
    const arr = yield call(putNotify, {response})
    const cameras = Array.isArray(arr)
      ? arr
      : []
    yield put({type: FETCH_CAMERAS_BY_PERMISSION_SUCCESS, camerasByPermission: cameras});
  }
}


function* fetchCategories({token}) {
  try {
    return yield call(camera.fetchCategories, token)
  } catch (error) {
    yield put({type: FETCH_CAMERA_CATEGORIES_FAILURE, error: error.message})
    return error
  }
}

export function* watchFetchCategories() {
  while (true) {
    yield take(FETCH_CAMERAS_REQUEST)
    const token = yield select(getTokenFromState);
    const response = yield call(fetchCategories, {token})
    const categories = yield call(putNotify, {response})
    yield put({type: FETCH_CAMERA_CATEGORIES_SUCCESS, categories: categories});
  }
}

function* createCamera({token, systemID, newCameraState}) {
  yield put({type: SENDING_CAMERA_CREATE, sending: true})
  try {
    return yield call(camera.postCamera, token, systemID, newCameraState)
  } catch (error) {
    yield put({type: CREATE_CAMERA_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_CAMERA_CREATE, sending: false})
  }
}

export function* watchCreateCameraRequest() {
  while (true) {
    const {newCameraState} = yield take(CREATE_CAMERA_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(createCamera, {token, systemID, newCameraState})
    const notify = `Thêm mới camera [${newCameraState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_CAMERAS_REQUEST});
  }
}

function* updateCamera({token, systemID, updateCameraState}) {
  yield put({type: SENDING_CAMERA_UPDATE, sending: true})
  try {
    return yield call(camera.updateCamera, token, systemID, updateCameraState)
  } catch (error) {
    yield put({type: UPDATE_CAMERA_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_CAMERA_UPDATE, sending: false})
  }
}

export function* watchUpdateCameraRequest() {
  while (true) {
    const {updateCameraState} = yield take(UPDATE_CAMERA_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updateCamera, {token, systemID, updateCameraState})
    const notify = `Cập nhật camera [${updateCameraState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_CAMERAS_REQUEST});
  }
}

function* deleteCamera({token, systemID, deleteCameraState}) {
  yield put({type: SENDING_CAMERA_DELETE, sending: true})
  try {
    return yield call(camera.deleteCamera, token, systemID, deleteCameraState)
  } catch (error) {
    yield put({type: DELETE_CAMERA_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_CAMERA_DELETE, sending: false})
  }
}

export function* watchDeleteCameraRequest() {
  while (true) {
    const {deleteCameraState} = yield take(DELETE_CAMERA_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(deleteCamera, {token, systemID, deleteCameraState})
    const notify = `Xoá camera [${deleteCameraState.Name}] thành công!`
    yield call(putNotify, {response, notify})
    yield put({type: FETCH_CAMERAS_REQUEST});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/camera.js